<template>
  <div class="course-task-new-contain">
    <section class="course-task-new-filter">
      <div class="filter-lf">
        <div class="filter-lf-line clearfix">
          <div class="filter-module clearfix">
            <p class="module-name">{{ $t('courseTask.taskName') }}</p>
            <div class="module-value module-value3">
              <el-input
                v-model="courseTask.name"
                size="small"
                :placeholder="$t('contract.inputTips')"
                maxlength="50"
                show-word-limit
                @keyup.enter.native="addNewTask()"
                v-if="!isAdd"
                clearable
                :disabled="isEditDetail"
              ></el-input>
              <el-input
                v-model="courseTask.name"
                size="small"
                :placeholder="$t('contract.inputTips')"
                maxlength="50"
                show-word-limit
                v-else
                clearable
                :disabled="isEditDetail"
              ></el-input>
            </div>
          </div>
          <div class="filter-module clearfix">
            <p class="module-name">{{ $t('courseTask.taskArrange') }}</p>
            <div class="module-value module-value2">
              <div class="module-svalue">
                <el-date-picker
                  v-model="courseTask.startTime"
                  type="date"
                  size="small"
                  :placeholder="$t('datePicker.start')"
                  format="yyyy-MM-dd"
                  :picker-options="pickOptions"
                  :disabled="isEditDetail || isAdd"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
              <div class="module-svalue-split"> - </div>
              <div class="module-svalue">
                <el-date-picker
                  v-model="courseTask.endTime"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  :picker-options="pickOptions2"
                  :disabled="isEditDetail || isAdd"
                  :placeholder="$t('datePicker.end')"
                  value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-lf-line clearfix">
          <div class="filter-module filter-module3 clearfix">
            <p class="module-name">{{ $t('courseTask.maxWorking') }}</p>
            <div class="module-value">
              <el-input-number v-model="courseTask.maxWorking" 
                :min="0" :max="30" :disabled="isEditDetail || isAdd"></el-input-number>
            </div>
          </div>
          <div class="filter-module filter-module3 clearfix">
            <p class="module-name">{{ $t('courseTask.maxWorkingRelease') }}</p>
            <div class="module-value">
              <el-input-number v-model="courseTask.maxWorkingRelease"
              :min="0" :max="15" :disabled="isEditDetail || isAdd"></el-input-number>
            </div>
          </div>
          <div class="filter-module filter-module3 clearfix">
            <p class="module-name">{{ $t('courseTask.isFirstTrainer') }}
               <el-tooltip placement="top-start" effect="light">
                <div slot="content">{{ $t("courseTask.isFirstTrainerInfo") }}</div>
                <em class="el-icon-question icon-blue"></em>
              </el-tooltip>
            </p>
            <div class="module-value">
              <el-switch
                v-model="courseTask.localTrainer"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否">
              </el-switch>
            </div>
          </div>
        </div>
        <div class="filter-lf-line">
          <div class="filter-module filter-module2 clearfix">
            <p class="module-name">{{ $t('courseTask.taskRemark') }}</p>
            <div class="module-value">
              <el-input
                v-model="courseTask.remark"
                type="textarea"
                :rows="3"
                resize="none"
                :placeholder="$t('contract.inputTips')"
                maxlength="200"
                style="padding: 0 64px 0 0"
                show-word-limit
                :disabled="isEditDetail"
                @keyup.enter.native="addNewTask()"
                clearable
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-lr" v-if="!scheduleTaskId || isEdit || isNew || isCopy">
        <el-button class="M-search buttons-margin" type="primary"
          @click="addNewTask" :loading="addLoading" v-if="!isAdd">
              {{ $t("confirm") }}
          </el-button>
      </div>
    </section>
    <section class="course-task-new-content" v-if="isCopy || saveId">
      <article class="task-new-buttons">
        <el-tooltip placement="top-start" effect="light" v-if="(!scheduleTaskId || isEdit || isNew || isCopy)&&!isAdd">
          <div slot="content">{{ $t("courseTask.addTips") }}</div>
          <el-button type="primary" @click="addNewCourse" :disabled="!saveId">
            {{ $t("add") }}
            <em class="el-icon-question"></em>
          </el-button>
        </el-tooltip>
        <el-button type="primary" :loading="downloadTask" @click="downloadData">
          {{ $t("export") }}
        </el-button>
        <el-button type="primary" @click="showUpload" :disabled="!saveId" v-if="(isEdit || isNew || isCopy)&& !isAdd">
          {{ $t("courseTask.mutiImportInfo") }}
        </el-button>
      </article>
      <article class="task-new-add clearfix" v-if="newCourseShow">
        <div class="task-new-lf clearfix">
          <div class="add-module add-module2" @click="showCourse">
            <el-button type="primary">
              {{ $t("res.rela.alternativeCourse") }}
            </el-button>
          </div>
          <div class="add-module">
            <p class="add-module-name">{{ $t('courseSchedule.choseCourseCode') }}</p>
            <div class="add-module-value">
              <el-input
                v-model="courseData.courseCode"
                :placeholder="$t('cert.selectTips')"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="add-module add-module5">
            <p class="add-module-name">{{ $t('courseSchedule.choseCourseTime') }}</p>
            <div class="add-module-value">
              <el-input
                v-model="courseData.courseDays"
                :placeholder="''"
                disabled
              ></el-input>
            </div>
          </div>
          <div class="add-module add-module5" v-if="weekShow">
            <p class="add-module-name">{{ $t('courseSchedule.weekendClass') }}</p>
            <div class="add-module-value">
              <el-select v-model="courseData.weekendArrangeFlag">
                <el-option
                  v-for="item in weekClassList"
                  :key="'weekendsClass'+item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="add-module">
            <p class="add-module-name add-module-name2" @click="showSite">{{ $t('courseSchedule.choseArea') }}</p>
            <div class="add-module-value">
              <el-tooltip class="item"
                  :content="courseData.siteNameCode"
                  :disabled="!courseData.siteNameCode || courseData.siteNameCode.length<14"
                    placement="top">
                  <el-input
                    v-model="courseData.siteNameCode"
                    class="add-module-value-info"
                    :placeholder="$t('cert.selectTips')"
                    disabled
                  ></el-input>
              </el-tooltip>
            </div>
          </div>
          <div class="add-module add-module4">
            <p class="add-module-name">{{ $t('courseTask.taskNum') }}</p>
            <div class="add-module-value">
              <el-input-number v-model="courseData.num" :min="0" :max="99" ref="couseDataNum"></el-input-number>
            </div>
          </div>
        </div>
        <div class="task-new-lr">
          <el-button type="primary" @click="addNewCourseData" :loading="newCourseLoading">
            {{ $t("confirm") }}
          </el-button>
          <el-button type="info" @click="closeAddCourse" :loading="newCourseLoading">
            {{ $t("cancel") }}
          </el-button>
        </div>
      </article>
      <article class="task-new-list">
        <p class="task-new-list-title" v-if="!isAdd">{{ $t('courseTask.copyInfo') }}</p>
        <el-table v-loading="taskLoading" border class="course-task-table" ref="taskTable" 
          :height="calHeight" :data="taskData" stripe :span-method="arraySpanMethod">
          <el-table-column
            type="index"
            :label="$t('pop.no')"
            header-align="center"
            align="center"
            fixed
            width="55">
          </el-table-column>
          <template v-for="(item,kindex) in columnList">
            <el-table-column :prop="item.prop"
                          :key="'courseSchedule'+item.prop"
                          show-overflow-tooltip
                          :width="item.width"
                          header-align="center"
                          align="center"
                          :formatter="item.formatter"
                          :label="item.label">
                <template slot-scope="scope">
                  <div v-if="item.prop === 'courseCode'"
                  class="course-task-value-link" @click.stop="goCourse(scope.row)">{{ scope.row[item.prop] + 
                  '(' + scope.row['courseDays'] + ')' }}</div>
                  <div v-else-if="item.prop === 'setMode'">{{ filterSettingMode(scope.row[item.prop]) }}</div>
                  <div v-else-if="item.prop === 'courseName'"
                  class="course-task-value-wrap">{{ scope.row[item.prop] + '-' + scope.row['courseTotal'] }}</div>
                  <div v-else-if="item.prop === 'siteName'" class="course-task-value-wrap">{{ scope.row[item.prop] 
                    + '-' + scope.row['total'] }}</div>
                  <div v-else-if="item.prop === 'district'" >{{ scope.row[item.prop] 
                    + '-' + scope.row['districtTotal'] }}</div>
                  <div v-else-if="item.prop==='weekendArrangeFlag'">
                    <span v-if="scope.row.isEdit || scope.row.weekEdit">
                      <el-select v-model="scope.row[item.prop]" class="course-task-select">
                        <el-option
                          v-for="(item,index) in weekClassList"
                          :key="'weekarrange'+index"
                          :label="item.name"
                          :value="item.code"
                        >
                        </el-option>
                      </el-select>
                    </span>
                    <span class="course-add-table-cell" v-else>{{ filterWeekArrange(scope.row[item.prop]) }}</span>
                  </div>
                  <div v-else-if="item.prop==='total'">
                    <span v-if="scope.row.isEdit">
                      <el-input
                        v-model="scope.row[item.prop]"
                        maxlength="2"
                        class="course-task-select"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        @blur="getSeries($event, item.prop, scope.$index)"
                      ></el-input>
                    </span>
                    <span class="course-add-table-cell" v-else>{{ scope.row[item.prop] }}</span>
                  </div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
            </el-table-column>
          </template>
          <el-table-column fixed="right" align="center" width="110"
            :label="$t('handle')" v-if="isNew || isCopy || isEdit ||isAdd">
            <template slot-scope="scope" v-if="checkPermission(scope.row)">
              <span :class="['schedule-manage-operate', { 'schedule-manage-operate3': isCopy && !saveId }]"
                v-if="!scope.row.isEdit" @click="edtiSchedule(scope.$index)">{{  $t("course.edit") }}</span>
              <span :class="['schedule-manage-operate', 'schedule-manage-operate2',
              { 'schedule-manage-operate3': isCopy && !saveId }]" v-if="!scope.row.isEdit" 
                @click="deleteSchedule(scope.row)">{{  $t("delete") }}</span>
              <span class="schedule-manage-operate" v-if="scope.row.isEdit" 
                @click="saveSchedule(scope.row)">{{  $t("save") }}</span>
              <span class="schedule-manage-operate schedule-manage-operate2" 
                v-if="scope.row.isEdit" @click="closeSave()">{{  $t("cancel") }}</span>
            </template>
          </el-table-column>
        </el-table>
      </article>
    </section>
    <section class="course-task-new-operate" v-if="scheduleTaskId || saveId">
      <el-button class="course-task-back" @click="backList">
        {{ scheduleTaskId && !isEdit ?  $t("user.back") : $t("cancel") }}
      </el-button>
      <el-button type="primary" @click="validCheck" 
        v-if="!scheduleTaskId || isEdit  || isNew || isCopy" :disabled="taskLoading">
        {{ $t("save") }}
      </el-button>
      <el-button type="success" @click="executionTask" :disabled="taskLoading">
        {{ $t("courseTask.execution2") }}
      </el-button>
    </section>
    <!-- 场地选择弹框 -->
    <courseSiteChose 
      :dialogShow="siteShow"
      @closeSiteChose="handleCloseSiteModal"
      v-if="siteShow" :courseId="courseId"
      :siteIds="siteIds"
      :courseType="siteCourseType"
      :searchFlag="searchFlag"
      :searchParam="saveId"
      :isCourse="true"></courseSiteChose>
    <!-- 课程选择弹框 -->
    <courseChose :dialogShow="courseShow" 
      @closeCourseChose="handleCloseCourseModal"
      v-if="courseShow"
      :courseTaskNew="courseTaskNew"></courseChose>
    <!-- 错误弹出 -->
    <errorModal v-if="errorVisible" 
      :errorVisible="errorVisible"
      :isErrorContinue="isErrorContinue"
      @closeModal="closeError"
      :errorData="errorData"
      :taskType="taskType"
      :errorTitle="courseTask.name"
      :taskName="courseTask.name"></errorModal>
     <!-- 上传文件弹框 -->
    <courseUpload :dialogShow="uploadShow" 
      @closeUploadChose="handleCloseUpload"
      v-if="uploadShow"
      :taskId="scheduleTaskId"></courseUpload>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import courseSiteChose from '@/views/modules/rm/courseSchedule/courseSiteModal.vue';
import courseChose from '@/views/modules/rm/courseSchedule/courseModal.vue';
import errorModal from './courseCheckModal.vue';
import courseUpload from './courseTaskUploadModal.vue';

export default {
  components: {
    courseSiteChose,
    courseChose,
    errorModal,
    courseUpload
  },
  data() {
    return {
      courseTask: {
        name: '',
        startTime: '',
        endTime: '',
        maxWorking: 15,
        maxWorkingRelease: 5,
        remark: '',
        localTrainer: 1
      },
      courseTaskNew: false,
      weekShow: false,
      isAdd: false,
      courseData: {
        courseCode: '',
        courseDays: null,
        siteNameCode: '',
        weekendArrangeFlag: '0',
        num: 0
      },
      taskType: 1,
      settingList: this.enums['yearTargetSetMode'],
      weekClassList: this.enums['weekArrangeFlag'],
      columnList: [
        { label: this.$t('courseSchedule.courseGroup'), prop: 'courseTeamCatalogNames', width: 120 },
        { label: this.$t('courseSchedule.courseType'), prop: 'courseKindName' },
        { label: this.$t('courseSchedule.courseIndex'), prop: 'courseCode', width: 130 },
        { label: this.$t('courseSchedule.courseCalculate'), prop: 'courseName' },
        { label: this.$t('courseSchedule.weekendClass'), prop: 'weekendArrangeFlag', width: 100 },
        { label: this.$t('courseSchedule.areaCalculate'), prop: 'district'},
        { label: this.$t('courseSchedule.siteCalculate'), prop: 'siteName' },
        { label: this.$t('courseTask.taskNum'), prop: 'total', width: 140 }
      ],
      spanArr1: [],
      spanArr2: [],
      spanArr3: [],
      spanArr4: [],
      spanArr5: [],
      taskData: [],
      taskLoading: false,
      siteShow: false,
      courseShow: false,
      uploadShow: false,
      courseId: '',
      siteIds: [],
      courseType: '',
      uploadParams: {},
      courseTypeKey: '',
      siteCourseType: '',
      scheduleTargetRecordId: '',
      downloadTask: false,
      addLoading: false,
      scheduleTaskId: '',
      scheduleTaskIdCopy: '',
      isEdit: false,
      newCourseShow: false,
      saveLoading: true,
      delLoading: true,
      disableAdd: false,
      isEditDetail: false,
      isCopy: false,
      errorVisible: false,
      addStatus: false,
      errorData: null,
      originData: [],
      originDataMap: {},
      saveId: '',
      isErrorContinue: false,
      saveTaskLoading: false,
      isExecute: false,
      calHeight: 400,
      newCourseLoading: false,
      searchFlag: 2,
      searchParam: '',
      pickOptions: {
        disabledDate: (time) => {
          const nowDate = new Date();
          if (this.courseTask.endTime) {
            const year = this.courseTask.endTime.substr(0, 4);
            return time.getTime() >= new Date(this.courseTask.endTime + ' 00:00:00').getTime()
              || time.getTime() < new Date(year + '-01-01 00:00:00').getTime() || 
              time.getTime() <= new Date(`${nowDate.getFullYear()  }-${  
              nowDate.getMonth() + 1  }-${  nowDate.getDate()  } 23:59:59`).getTime();
          }
          return time.getTime() <= new Date(`${nowDate.getFullYear()  
          }-${  nowDate.getMonth() + 1  }-${  nowDate.getDate()  } 23:59:59`).getTime();
        }
      },
      pickOptions2: {
        disabledDate: (time) => {
          const nowDate = new Date();
          if (this.courseTask.startTime) {
            const year = this.courseTask.startTime.substr(0, 4);
            return time.getTime() <= new Date(this.courseTask.startTime + ' 23:59:59').getTime() || 
                  time.getTime() > new Date(year + '-12-31 23:59:59').getTime() || 
                  time.getTime() <= new Date(`${nowDate.getFullYear()  }-${  nowDate.getMonth() + 1  }-${ 
                  nowDate.getDate()  } 23:59:59`).getTime();
          }
          return time.getTime() <= new Date(`${nowDate.getFullYear()  }-${  nowDate.getMonth() + 1 
           }-${  nowDate.getDate()  } 23:59:59`).getTime();
        }
      }
    };
  },
  methods: {
    checkPermission (row) {
      const dic = 'SC_TASK_EDIT:' + row.courseTeamCatalogSecond;
      if (JSON.parse(sessionStorage.getItem('v1user_data')).userCode === 'admin') {
        return true;
      }
      return this.$hasPermission(dic);
    },
    filterSettingMode (val) {
      for(let i of this.settingList) {
        if (val === i.code) {
          return i.name;
        }
      }
    },
    filterWeekArrange (val) {
      for(let i of this.weekClassList) {
        if (val*1 === i.code*1) {
          return i.name;
        }
      }
    },
    taskDataValidInfo () {
      let flag = true;
      let msg = '';
      if (!this.courseTask.name) {
        flag = false;
        msg += this.$t('courseTask.needInput1');
      }
      if (!this.courseTask.startTime || !this.courseTask.endTime) {
        flag = false;
        msg += this.$t('courseTask.needInput2');
      }
      if (this.courseTask.maxWorking === undefined) {
        flag = false;
        msg += this.$t('courseTask.needInput3');
      }
      if (this.courseTask.maxWorkingRelease === undefined) {
        flag = false;
        msg += this.$t('courseTask.needInput4');
      }
      return { flag, msg};
    },
    // 点击确定 校验页面基本信息 
    addNewTask () {
      const info = this.taskDataValidInfo();
      if (!info.flag) {
        this.$message({
          message: info.msg,
          type: 'warning'
        });
        return false;
      }
      this.addLoading = true;
      this.isExecute = false;
      const params = this.validParams();
      params.status = 0;
      const taskData = this.taskData.map((item) => {
        return { ...item, 'courseKind': item.courseTypeKey };
      });
      if (taskData.length > 0) {
        params.targetRecords = taskData;
      } 
      if (!this.isNew && !this.isCopy) {
        params.id = this.scheduleTaskId;
      }
      if (this.saveId) {
        params.id = this.saveId;
      }
      this.$request.post('/classschedule/scheduleTask/save', params).then((res) => {
        if (res) {
          this.scheduleTaskId = res;
          this.saveId = res;
          this.searchList(true);
        }
        this.addLoading = false;
      }).catch(() => {
        this.addLoading = false;
      });
    },
    addNewCourse () {
      this.newCourseShow = true;
      this.resetCourseData();
    },
    closeAddCourse () {
      this.newCourseShow = false;
      this.resetCourseData();
    },
    resetCourseData () {
      this.courseData = {
        courseCode: '',
        courseDays: null,
        siteNameCode: '',
        weekendArrangeFlag: '0',
        num: 0
      };
    },
    // 新增课程场地
    addNewCourseData () {
      this.$refs.couseDataNum.$el.focus();
      if (!this.courseId || !this.courseData.num || !this.courseData.siteId || this.courseData.siteId.length === 0 ) {
        this.$message({
          message: this.$t('courseTask.addCourseInfo'),
          type: 'warning'
        });
        return false;
      }
      this.newCourseLoading = true;
      const year = this.courseTask.startTime.substr(0, 4);
      const params = {
        scheduleTaskId: this.isCopy ? this.saveId : this.scheduleTaskId,
        year: year * 1,
        courseType: this.courseType,
        courseTypeKey: this.courseTypeKey,
        courseId: this.courseId,
        weekendArrangeFlag: this.weekShow ? this.courseData.weekendArrangeFlag*1 : null,
        total: this.courseData.num,
        siteIds: this.courseData.siteId
      };
      if (this.scheduleTargetRecordId) {
        params.scheduleTargetRecordId = this.scheduleTargetRecordId;
      }
      this.$request.post('/classschedule/scheduleTask/saveScheduleTaskRecord', params)
      .then((_res, _total, _code, data) => {
        if (data.msg === 'success') {
          this.$message({
            message: this.$t('courseTask.addCourseSuccess2'),
            type: 'success'
          });
          this.newCourseLoading = false;
          this.resetAndClose(true, true);
        }
      }).catch(() => {
        this.newCourseLoading = false;
        this.resetAndClose(false, false);
      });
    },
    resetAndClose (type, isSave) {
      this.resetCourseData();
      this.newCourseShow = false;
      this.courseId = '';
      this.courseType = '';
      this.courseTypeKey = '';
      this.weekShow = false;
      this.siteCourseType = '';
      this.siteIds = [];
      if (type) {
        this.searchList(isSave);
      }
    },
    // 查询排课列表
    searchList (isSave) {
      if (this.scheduleTaskId || this.saveId) {
        this.resetList();
        const params = {
          id: this.scheduleTaskId || this.saveId
        };
        this.taskLoading = true;
        this.taskData = [];
        this.$request.get('/classschedule/scheduleTask/getByTaskId', params).then((res) => {
        if (res) {
            this.taskData = res.targetRecords.map((item) => {
              return { ...item, weekendArrangeFlag: item.weekendArrangeFlag.toString(), isEdit: false };
            });
            this.originData = JSON.parse(JSON.stringify(this.taskData));
            this.courseTask =  {
              name: this.isCopy && !this.saveId ? '' : res.taskName,
              startTime: dayjs(res.arrangeStartDate).format('YYYY-MM-DD'),
              endTime: dayjs(res.arrangeEndDate).format('YYYY-MM-DD'),
              maxWorking: res.maxContinuousDays,
              maxWorkingRelease: res.restDays,
              remark: this.isCopy && !this.saveId ? '' : res.remark,
              localTrainer: res.localTrainer
            };
            this.originDataMap = JSON.parse(JSON.stringify(this.courseTask));
            this.addStatus = this.isCopy && !this.saveId ? -1 : res.status;
            this.saveId = this.isCopy ? '' : res.id;
            if (this.isCopy && isSave) {
              this.saveId = res.id;
            }
            this.resetArraySpan();
            this.mergeData();
            this.taskLoading = false;
          }
        }).catch(() => {
          this.taskLoading = false;
        });
      }
    },
    resetArraySpan () {
      this.spanArr1 = [];
      this.spanArr2 = [];
      this.spanArr3 = [];
      this.spanArr4 = [];
      this.spanArr5 = [];
    },
    // 合并单元格
    arraySpanMethod ({ _row, _column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return {
          rowspan: this.spanArr1[rowIndex],
          colspan: this.spanArr1[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 2) {
        return {
          rowspan: this.spanArr2[rowIndex],
          colspan: this.spanArr2[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 3) {
        return {
          rowspan: this.spanArr3[rowIndex],
          colspan: this.spanArr3[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 4 || columnIndex === 5) {
        return {
          rowspan: this.spanArr4[rowIndex],
          colspan: this.spanArr4[rowIndex] > 0 ? 1 : 0
        };
      } else if (columnIndex === 6) {
        return {
          rowspan: this.spanArr5[rowIndex],
          colspan: this.spanArr5[rowIndex] > 0 ? 1 : 0
        };
      }
    },
    mergeData () {
      let index1 = 0;
      let index2 = 0;
      let index3 = 0;
      let index4 = 0;
      let index5 = 0;
      const data = this.taskData;
      for(let [k, i] of data.entries()) {
        if (k === 0) {
          this.spanArr1.push(1);
          this.spanArr2.push(1);
          this.spanArr3.push(1);
          this.spanArr4.push(1);
          this.spanArr5.push(1);
        } else {
          if (i.courseTeamCatalogNames === data[k - 1].courseTeamCatalogNames && 
          i.courseCode === data[k-1].courseCode) {
            this.spanArr1[index1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            index1 = k;
          }
          if (i.courseCode === data[k-1].courseCode && i.courseKindName === data[k-1].courseKindName) {
            this.spanArr2[index2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            index2 = k;
          }
          if (i.courseCode === data[k-1].courseCode) {
            this.spanArr3[index3] += 1;
            this.spanArr3.push(0);
          } else {
            this.spanArr3.push(1);
            index3 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames && 
            i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode
            && i.courseName === data[k-1].courseName) {
            this.spanArr4[index4] += 1;
            this.spanArr4.push(0);
          } else {
            this.spanArr4.push(1);
            index4 = k;
          }
          if (i.courseTeamCatalogNames === data[k-1].courseTeamCatalogNames && 
            i.courseKindName === data[k-1].courseKindName && i.courseCode === data[k-1].courseCode && 
            i.courseName === data[k-1].courseName && i.district === data[k-1].district) {
            this.spanArr5[index5] += 1;
            this.spanArr5.push(0);
          } else {
            this.spanArr5.push(1);
            index5 = k;
          }
        }
      }
    },
    getSeries (e, keyName, bindex) {
      this.$set(this.taskData[bindex], keyName, e.target.value);
    },
    edtiSchedule (index) {
      if (this.isCopy && !this.saveId) {
        return false;
      }
      if (this.taskData.filter((item) => item.isEdit).length === 0) {
        this.$set(this.taskData[index], 'isEdit', true);
        const { courseTeamCatalogNames, courseKindName, courseCode, courseName } = this.taskData[index];
        for(let [k, i] of this.taskData.entries()) {
          if (k !== index) {
            if (i.courseTeamCatalogNames === courseTeamCatalogNames && i.courseKindName === courseKindName 
            && i.courseCode === courseCode && i.courseName === courseName) {
              this.$set(this.taskData[k], 'weekEdit', true);
            }
          }
        }
      } else {
        this.$message({
          message: this.$t('courseSchedule.editOneInfo'),
          type: 'warning',
        });
      }
    },
    // 删除
    deleteSchedule (val) {
      if (this.isCopy && !this.saveId) {
        return false;
      }
      this.$confirm(this.$t('courseTask.delTargetInfo'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        if (this.delLoading) {
          this.delLoading = false;
          const params = { 
            scheduleTargetDetailRecordId: val.scheduleTargetDetailsRecordId,
            scheduleTargetRecordId: val.scheduleTargetRecordId
          };
          this.$request.post('/classschedule/scheduleTask/deleteScheduleTaskDetail', params)
          .then((_res, _total, _code, data) => {
            if (data.msg === 'success') {
              this.$message({
                message: this.$t('courseTask.delSuccess'),
                type: 'success'
              });
              this.delLoading = true;
              this.searchList(true);
            }
          }).catch(() => {
            this.delLoading = true;
          });
        }
      });
    },
    closeSave () {
      this.searchList(true);
    },
    // 编辑保存单条
    saveSchedule (val) {
      if (this.saveLoading) {
        this.saveLoading = false;
        if (val.total === 0) {
          this.$message({
            message: this.$t('courseTask.newEditNum'),
            type: 'warning',
          });
          this.saveLoading = true;
          return false;
        }
        const params = {
          scheduleTargetRecordId: val.scheduleTargetRecordId,
          scheduleTargetDetailRecordId: val.scheduleTargetDetailsRecordId,
          weekendArrangeFlag: val.weekendArrangeFlag*1,
          total: val.total
        };
        this.$request.post('/classschedule/scheduleTask/editScheduleTargetRecord', params)
        .then((_res, _total, _code, data) => {
          if (data.msg === 'success') {
            this.$message({
              message: this.$t('courseTask.editSuccess'),
              type: 'success'
            });
            this.saveLoading = true;
            this.searchList(true);
          }
        }).catch(() => {
          this.saveLoading = true;
        });
      }
    },
    closeError (val) {
      this.errorVisible = false;
      this.errorData = null;
      if (val === 1) {
        const params = this.validParams();
        this.saveNewTask(params);
      } else {
        this.taskLoading = false;
        this.saveTaskLoading = false;
      }
    },
    showCourse () {
      this.courseShow = true;
    },
    showSite () {
      this.siteShow = true;
    },
    handleCloseSiteModal (val) {
      this.siteShow = false;
      this.siteIds = [];
      if (val && val.siteInfo.length > 0) {
        this.courseData.siteNameCode = val.siteInfo.map((item) => item.siteCnName).join('/');
        this.courseData.siteId = val.siteInfo.map((item) => item.siteId);
        this.siteIds = val.siteInfo.map((item) => item.siteId);
      } else {
        this.courseData.siteId = [];
      }
    },
    // 选择课程回调
    handleCloseCourseModal (val) {
      this.courseShow = false;
      this.courseData = {
        courseData: '',
        weekendArrangeFlag: '0',
        courseDays: null,
        num: 0
      };
      this.siteIds = [];
      this.scheduleTargetRecordId = '';
      if (val && val.courseInfo && val.courseInfo.courseKind) {
        this.courseData.courseCode = val.courseInfo.courseCode
        this.courseData.courseDays = val.courseInfo.courseScheduledDays || null;
        if (val.courseInfo.courseKind.indexOf('courseKind') >= 0) {
          this.courseTypeKey = val.courseInfo.courseKind.substr(10);
          this.courseType = 'courseKind';
          this.siteCourseType = '';
        }
        if (val.courseInfo.courseKind.indexOf('courseGroupType') >= 0) {
          this.courseTypeKey = val.courseInfo.courseKind.substr(15);
          this.courseType = 'courseGroupType';
          this.siteCourseType = this.courseTypeKey === '1' ? '2' : '3';
        }
        this.courseId = val.courseInfo.courseId;
        this.$request.get(`/classschedule/scheduleTask/queryScheduleTaskRecordByCourseId?courseId=
        ${val.courseInfo.courseId}&taskId=${this.scheduleTaskId}`)
        .then((res) => {
          if (res === null) {
            this.weekShow = true;
          } else {
            this.scheduleTargetRecordId = res;
          }
        });
      } else {
        this.courseId = '';
      }
    },
    // 跳转课程
    goCourse (val) {
      if (val.courseType === 'courseKind') {
        this.$router.push({
          name: 'learning-course-courseShow',
          query: {
            courseId: val.courseId
          }
        });
        this.$eventHub.$emit('showViewCourse', '');
      } else {
        this.$router.push({
          name: 'rm-courseGroup-courseGroupDetail',
          query: {
            id: val.courseId
          }
        });
        this.$eventHub.$emit('courseGroupDetail', '');
      }
    },
    goPage () {
      this.resetList();
      this.tabRemove();
      this.$router.push({
        name: 'rm-courseTask-courseTaskManage'
      });
      this.$eventHub.$emit('courseTaskManage', true);
    },
    backList () {
      if (this.scheduleTaskId && !this.isEdit && !this.isCopy) {
        this.goPage();
      } else {
        if (JSON.stringify(this.taskData) === JSON.stringify(this.originData) 
          && JSON.stringify(this.originDataMap) === JSON.stringify(this.courseTask)) {
          this.goPage();
          return false;
        }
        const info = this.scheduleTaskId && !this.isCopy ? 
          this.$t('courseTask.delTaskInfo4') : this.$t('courseTask.delTaskInfo')
        this.$confirm(info, this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          this.goPage();
        });
      }
    },
    validParams () {
      const data = this.taskData.map((item) => {
        return { ...item, 'courseKind': item.courseTypeKey };
      });
      return {
        id: this.isCopy ? this.saveId : this.scheduleTaskId,
        taskType: 1,
        taskName: this.courseTask.name,
        remark: this.courseTask.remark,
        arrangeStartDate: this.courseTask.startTime + ' 00:00:00',
        arrangeEndDate: this.courseTask.endTime + ' 23:59:59',
        maxContinuousDays: this.courseTask.maxWorking,
        restDays: this.courseTask.maxWorkingRelease,
        targetRecords: data,
        localTrainer: this.courseTask.localTrainer
      };
    },
    // 保存校验
    validCheck () {
      const info = this.taskDataValidInfo();
      this.isExecute = false;
      if (!info.flag) {
        this.$message({
          message: info.msg,
          type: 'warning'
        });
        return false;
      }
      const params = this.validParams();
      this.taskLoading = true;
      this.saveTaskLoading = true;
      this.$request.post('/classschedule/coursePkgCheck/checkTaskWhenSave', params).then((res) => {
        if (res) {
          this.isErrorContinue = false;
          if (res.status === -1 ) {
            this.errorData = res.data;
            this.errorVisible = true;
            this.taskLoading = false;
          } else if (res.status === -2) { 
            this.$message({
              message: res.message,
              type: 'warning',
            });
            this.taskLoading = false;
            this.saveTaskLoading = false;
          } else if (res.status === -3) { 
            this.errorData = res.data;
            this.errorVisible = true;
            this.isErrorContinue = true;
            this.taskLoading = false;
          } else {
            this.errorVisible = false;
            this.saveNewTask(params);
          }
        }
      }).catch(() => {
        this.taskLoading = false;
        this.saveTaskLoading = false;
      });
    },
    // 保存
    saveNewTask (params) {
      params.status = 1;
      this.taskLoading = true;
      this.$request.post('/classschedule/scheduleTask/save', params).then((res) => {
        this.$message({
          message: this.$t('courseTask.successLoad'),
          type: 'success',
          duration: 3000
        });
        this.scheduleTaskId = res;
        this.saveId = res;
        this.addStatus = 1;
        this.taskLoading = false;
        this.saveTaskLoading = false;
        this.originDataMap = this.courseTask;
        // 保存并执行
        if (this.isExecute) {
          this.executionTaskFinal(this.saveId);
        } else {
          this.goPage();
        }
      }).catch(() => {
        this.taskLoading = false;
        this.saveTaskLoading = false;
      });
    },
    // 执行
    executionTask () {
      const info = this.taskDataValidInfo();
      if (!info.flag) {
        this.$message({
          message: info.msg,
          type: 'warning'
        });
        return false;
      }
      const params = this.validParams();
      params.id = this.saveId;
      this.taskLoading = true;
      this.isExecute = false;
      this.$request.post('/classschedule/coursePkgCheck/checkTaskWhenSave', params).then((res) => {
        if (res) {
          this.isErrorContinue = false;
          if (res.status === -1 ) {
            this.errorData = res.data;
            this.errorVisible = true;
            this.taskLoading = false;
          } else if (res.status === -2) { 
            this.$message({
              message: res.message,
              type: 'warning',
            });
            this.taskLoading = false;
          } else if (res.status === -3) { 
            this.errorData = res.data;
            this.errorVisible = true;
            this.isErrorContinue = true;
            this.taskLoading = false;
            this.isExecute = true;
          } else {
            this.errorVisible = false;
            this.isExecute = true;
            this.saveNewTask(params);
          }
        }
      }).catch(() => {
        this.taskLoading = false;
        this.isExecute = false;
      });
    },
    executionTaskFinal (id) {
      this.taskLoading = true;
      this.$request.post(`/classschedule/scheduleTask/executeTask?scheduleTaskId=${id}`)
      .then((_res, _total, code, data) => {
        if (code === 10000006) {
          this.$confirm(data.msg, this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.sureQueue(id);
          }).catch(() => {
            this.taskLoading = false;
          });
        } else {
          this.$message({
            message: this.$t('courseTask.executionSuccess'),
            type: 'success',
          });
          this.taskLoading = false;
          this.goPage();
        }
      }).catch(() => {
        this.$message({
          message: this.$t('courseTask.executionFailed'),
          type: 'warning',
        });
        this.taskLoading = false;
        this.goPage();
      });
    },
    sureQueue (id) {
      this.$request.post(`/classschedule/scheduleTask/confirmInQueue?scheduleTaskId=${id}`).then(() => {
        this.taskLoading = false;
        this.goPage();
      }).catch(() => {
        this.taskLoading = false;
      });
    },
    // 导出
    downloadData () {
      clearTimeout(this.timeout);
      const params = {
        id: this.scheduleTaskId
      };
      this.downloadTask = true
      this.$request.downloadByPost7(
        '/classschedule/scheduleTask/export',
        `${this.courseTask.name + this.$t('courseTask.loadTaskDownload') 
        + dayjs().format('YYYY-MM-DD HH:mm:ss') }.xls`,
        params, null, 'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.timeout = setTimeout(() => {
        this.downloadTask = false;
      }, 2000) ;
    },
    // 重置数据
    resetList () {
      Object.keys(this.courseTask).forEach((item) => {
        this.courseTask[item] = '';
        if (item === 'maxWorking') {
          this.courseTask[item] = 15;
        }
        if (item === 'maxWorkingRelease') {
          this.courseTask[item] = 5;
        }
      });
      this.taskData = [];
      this.resetAndClose();
    },
    // 上传文件弹框
    showUpload () {
      this.uploadShow = true;
    },
    handleCloseUpload (val) {
      this.uploadShow = false;
      if (val.isFresh) {
        this.searchList();
      }
    },
    // 删除当前页面
    tabRemove() {
      const tabName = this.$store.state.contentTabsActiveName;
      if (tabName === 'home') {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName);
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home';
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name});
      }
    }
  },
  computed: {
    taskInfo() {
      return { scheduleTaskId: this.scheduleTaskId, isCopy: this.isCopy, saveId: this.saveId };
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'rm-courseTask-courseTaskNew') {
        this.scheduleTaskId = this.$route.query.taskId || '';
        this.isEdit = this.$route.query.isEdit === 'true' || this.$route.query.isEdit === true;
        this.isCopy = this.$route.query.isCopy === 'true' || this.$route.query.isCopy === true;
        this.isNew = !this.scheduleTaskId;
        this.isEditDetail = true;
        if (this.isNew) {
          this.isEditDetail = false;
        } else {
          this.isEditDetail = this.scheduleTaskId && !this.isEdit;
        }
        if (this.isCopy) {
          this.isEditDetail = false;
        }
      }
    },
    taskInfo: {
      handler(now, old) {
        if (now !== old && !this.saveId) {
          if (!this.isNew) {
            this.resetList();
            this.searchList();
            return false;
          }
          if (this.isCopy) {
            this.searchList();
            return false;
          }
        }
      }
    }
  },
  mounted() {
    this.isEdit = this.$route.query.isEdit === 'true' || this.$route.query.isEdit === true;
    this.isCopy = this.$route.query.isCopy === 'true' || this.$route.query.isCopy === true;
    this.isAdd = this.$route.query.isAdd === 'true' || this.$route.query.isAdd === true;
    this.scheduleTaskId = this.$route.query.taskId || '';
    this.isNew = !this.scheduleTaskId;
    this.isEditDetail = true;
    this.saveId = '';
    setTimeout(() => {
      this.calHeight = window.innerHeight - 100;
    });
    window.onresize = () => {
      setTimeout(() => {
        this.calHeight = window.innerHeight - 100;
      });
    };
    if (this.isNew) {
      this.isEditDetail = false;
    } else {
      this.isEditDetail = this.scheduleTaskId && !this.isEdit;
    }
    if (this.isCopy) {
      this.isEditDetail = false;
    }
    this.$eventHub.$on('courseTaskNew', () => {
      this.saveId = '';
    });
  },
  destroyed() {
    clearTimeout(this.timeout);
    this.timeout = null;
    this.scheduleTaskId = '';
    this.saveId = '';
    this.isEdit = false;
    this.isNew = true;
    this.isCopy = false;
    this.isAdd = false;
    this.resetList();
  }
};
</script>
<style lang="scss" scoped>
.course-task-new-contain {
  min-height: calc(100% - 120px);
  .course-task-new-filter {
    display: flex;
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    .filter-lf {
      flex: 8;
      .filter-lf-line {
        line-height: 34px;
        margin-bottom: 12px;
        .filter-module {
          float: left;
          width: 45%;
          margin-right: 5%;
          &.filter-module2 {
            width: calc(95% + 64px);
          }
          &.filter-module3 {
            width: 28%;
          }
          .module-name {
            line-height: 26px;
            margin: 0;
          }
          .module-svalue {
            flex: 1;
          } 
          .module-svalue-split {
            margin: 0 10px;
            float: left;
          }
          .module-value {
            line-height: 32px;
            &.module-value2 {
              display: flex;
            }
          }
          .icon-blue {
            color: #409eff;
          }
        }
      }
    }
    .filter-lr {
      flex: 1;
      vertical-align: middle;
      padding: 26px 0 0 20px;
      .buttons-margin {
        margin-bottom: 7px;
      }
      .buttons-margin2 {
        margin: 0;
      }
    }
  }
  .course-task-new-content {
    margin-bottom: 12px;
    .task-new-buttons, .task-new-add {
      background-color: #fff;
      margin-bottom: 12px;
      padding: 15px;
    }
    .task-new-add {
      display: flex;
      margin-bottom: 20px;
      .task-new-lf {
        flex: 1;
        align-items: center;
        display: flex;
      }
      .task-new-lr {
        width: 200px;
        padding-top: 23px;
        overflow: hidden;
      }
      .add-module {
        margin-right: 20px;
        float: left;
        &.add-module2 {
          padding-top: 24px;
          margin-right: 30px;
        }
        &.add-module4 {
          width: 140px;
        }
        &.add-module5 {
          width: 110px;
        }
        .add-module-name {
          line-height: 26px;
          margin: 0;
          padding: 0;
          &.add-module-name2 {
            color:#409eff;
            cursor: pointer;
          }
        }
      }
    }
    .task-new-list {
      background-color: #fff;
      margin-bottom: 12px;
      padding: 15px;
      .task-new-list-title {
        line-height: 25px;
        margin: 0 0 10px 0;
        padding: 0;
        text-align: left;
      }
      .course-task-table {
        width: 100%;
      }
    }
  }
  .course-task-new-operate {
    background-color: #fff;
    margin-bottom: 12px;
    padding: 15px;
    text-align: right;
  }
  .course-task-value-wrap {
    word-break: break-word;
    white-space: pre-wrap;
  }
  .course-task-value-link {
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
    word-break: break-all;
    white-space: pre-wrap;
    &.iscopy {
      color: #606266;
    }
  }
  .schedule-manage-operate {
    cursor: pointer;
    color: #409eff;
    &.schedule-manage-operate2 {
      margin-left: 10px;
    }
    &.schedule-manage-operate3 {
      cursor: not-allowed;
    }
    &:hover {
      opacity: .8;
    }
  }
}
</style>
<style lang="scss">
.course-task-new-contain{
  .module-value3 {
    .el-input__inner {
      padding-right: 65px !important;
    }
    .el-input__count-inner {
      background-color: transparent !important;
    }
  }
  .el-range-editor.el-input__inner {
    width: 100% !important;
  }
  .el-range-editor--small .el-range-separator {
    line-height: 32px !important;
  }
  .el-input-number{
    line-height: 32px !important;
    width: 100% !important;
  }
  .el-input__inner {
    line-height: 32px !important;
  }
  .el-button--default:hover {
    color: #409eff !important;
    border-color: #c6e2ff !important;
    background-color: #ecf5ff !important;
  }
  .el-button--primary:hover {
    background: #66b1ff !important;
    border-color: #66b1ff !important;
    color: #fff !important;
  }
  .el-button--success:hover, .el-button--success:focus  {
    background: #85ce61 !important;
    border-color: #85ce61 !important;
    color: #fff !important;
  }
  .el-button--success:active {
    background: #85ce61 !important;
    border-color: #85ce61 !important;
    color: #fff !important;
    opacity: .9;
  }
  .el-button--info {
    background: #535151!important;
    border: 1px solid #535151 !important;
    color: #fff !important;
  }
  .el-button--info:hover {
    opacity: .8;
    background: #535151!important;
    border: 1px solid #535151 !important;
    color: #fff !important;
  }
  .course-task-select {
    .el-input__inner {
      text-align: center !important;
    }
  }
  .add-module-value-info {
    .el-input__inner {
      text-overflow: ellipsis !important;
    }
  }
  .el-input__count {
    background-color: transparent !important;
  }
  .course-task-back {
    &:focus {
      border-color: #c6e2ff !important;
      background-color: #ecf5ff !important;
    }
  }
}
</style>